(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ing_page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.plus-icon').forEach(icon => {
  icon.addEventListener('click', () => {
    const id = icon.getAttribute('data-popup');
    document.getElementById('popup-' + id).classList.add('active');
  });
});

document.querySelectorAll('.popup-close').forEach(btn => {
  btn.addEventListener('click', () => {
    const id = btn.getAttribute('data-close');
    document.getElementById('popup-' + id).classList.remove('active');
  });
});

document.querySelectorAll('.popup').forEach(popup => {
  popup.addEventListener('click', e => {
    if (e.target === popup) popup.classList.remove('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
